module.exports = __webpack_public_path__ + "img/game_aoe_mod_sort_1.ae718261.jpg";